
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
import validatorService from "../../services/validator.service";
import { FormGroup } from "../../model/FormGroup.model";
import { Message } from "../../model/Message.model";
import { Rule } from "../../model/Rule.model";
import ErrorMessage from "../../services/errorMessage.service";
import TranslateService from "../../services/translate.service";
@Options({})
export default class BaseForm extends Base {
  public formGroup: FormGroup = {};
  public msg: Message = {};
  public msgType: Message = {};

  public onSubmit() {
    this.validateAll();
  }

  public blur(fieldName: string) {
    this.validateOne(fieldName);
  }

  public validateOne(fieldName: string) {
    const { value, rules } = this.formGroup[fieldName];
    const { errors } = validatorService(value, rules);
    const error: any = errors.value.find(e => e);
    TranslateService.currentLocale.subscribe(() => {
      const errorMessage = ErrorMessage.getValidatorErrorMessage(
        error?.name,
        error?.param
      );
      this.msg[fieldName] = errorMessage;
    });
  }

  public validateAll() {
    const fields = Object.keys(this.formGroup);
    fields.forEach((f: string) => {
      this.validateOne(f);
    });
  }

  public setValidation(formField: string, rule: Rule) {
    this.formGroup[formField].rules.push(rule);
  }

  public clearValidation(formField: string) {
    this.formGroup[formField].rules = [];
  }
}
